import { createContext, useContext } from "react";
import { ValidSource } from "@validator/schema";
import { ConsentTier, ReadFileFn, ReadFileErrorFn } from "@/types/submission";
import { StudyState, SubmissionState } from "@/reducers/app";

export interface StudyContextData extends StudyState {}

export type SubmissionType = "study" | "public";

export interface SubmissionContextData extends SubmissionState {
  type: SubmissionType;
  setConsentTier: (tier: ConsentTier | null) => void;
  onReadFile: ReadFileFn;
  onReadFileError: ReadFileErrorFn;
  upload: () => void;
  resetSubmission: () => void;
  resetValidation: () => void;
  setUserSource: (source: ValidSource | null) => void;
  setWeek: (week: number | null) => void;
  setOverrideDefaultWeek: (override: boolean) => void;
  setOverrideValidation: (override: boolean) => void;
}

export const StudyContext = createContext<StudyContextData | null>(null);
export const SubmissionContext = createContext<SubmissionContextData | null>(null);

export function useStudyContext() {
  const context = useContext(StudyContext);
  if (!context) throw new Error("useStudyContext must be used within AppProvider");
  return context;
}

export function useSubmissionContext() {
  const context = useContext(SubmissionContext);
  if (!context) throw new Error("useSubmissionContext must be used within AppProvider");
  return context;
}
